import { render, staticRenderFns } from "./StaleAccountsList.vue?vue&type=template&id=58b8cba4&scoped=true&"
import script from "./StaleAccountsList.vue?vue&type=script&lang=js&"
export * from "./StaleAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./StaleAccountsList.vue?vue&type=style&index=0&id=58b8cba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b8cba4",
  null
  
)

export default component.exports